import { JogId } from ".";
import { JogsForUsers } from "./jogs";

export const JogIdConversionMap = new Map<string, JogId>([
  ["0", JogId.Other],
  ["1", JogId.SeattleArea],
  ["2", JogId.KingCountyNortheast],
  ["3", JogId.KingCountySouth],
  ["4", JogId.Tacoma],
  ["5", JogId.JBLM],
  ["6", JogId.SnohomishCounty],
  ["7", JogId.KitsapPeninsula],
  ["8", JogId.ClarkCounty],
]);

export const sanitizeJogIds = (jogIds: string): string => {
  let jogIdSet = new Set(jogIds.split(","));
  if (jogIdSet.has(JogId.Wsp)) {
    // Add all JogIds to retrieve WSP events and any incidents for all WSP districts.
    // The check for jog.isUserJog will avoid including the "WSP" JogId,
    // so it's not sent in the API request, because it's not a real JogId.
    // And it will exlucde JogId.other, for performance reasons.
    const ids = JogsForUsers.map(jog => jog.id);

    return ids.join(",");
  } else {
    return jogIds;
  }  
}